import Component_MovingBoxes_dbe0057bcaf6598091b53b3c4e38a426 from "../../../../content/examples/basic/moving-boxes/MovingBoxes";
import Devtool_MovingBoxes_dbe0057bcaf6598091b53b3c4e38a426 from "!!@devtool/loader!../../../../content/examples/basic/moving-boxes/MovingBoxes";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_MovingBoxes_dbe0057bcaf6598091b53b3c4e38a426,
  Devtool_MovingBoxes_dbe0057bcaf6598091b53b3c4e38a426,
  DevTool,
  React
};